import { render } from "./release.vue?vue&type=template&id=541e6e0f&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"

import "./release.vue?vue&type=style&index=0&id=541e6e0f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-541e6e0f"

export default script